import { ExternalLink, Menu, Shield, Swords, Users } from 'lucide-react';
import { useMemo, useState } from 'react';
import { BrandMark } from './BrandMark';
import { Container } from './Container';

const links = [
  { href: '#players', label: 'Players', icon: Users },
  { href: '#world', label: 'World', icon: Swords },
  { href: '#faq', label: 'FAQ', icon: Shield }
];

export const SiteHeader = ({ address }) => {
  const [open, setOpen] = useState(false);

  const navLinks = useMemo(
    () =>
      links.map(link => ({
        ...link,
        Icon: link.icon
      })),
    []
  );

  return (
    <header className="sticky top-0 z-50 border-b border-white/5 bg-base-100/70 backdrop-blur">
      <Container className="py-3">
        <div className="flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-3">
            <BrandMark className="shrink-0" />
            <div className="leading-tight">
              <div className="text-base font-semibold tracking-wide">Kweebec World</div>
              <div className="text-xs text-base-content/70">{address}</div>
            </div>
          </a>

          <nav className="hidden items-center gap-6 md:flex">
            {navLinks.map(({ href, label }) => (
              <a key={href} href={href} className="text-sm text-base-content/80 transition hover:text-base-content">
                {label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <a
              href="https://discord.gg/69fQ5hqux9"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost btn-sm border border-white/10"
            >
              <ExternalLink className="h-4 w-4" />
              Discord
            </a>
            <a href="#join" className="btn btn-primary btn-sm">
              Join now
            </a>
          </div>

          <button
            type="button"
            className="btn btn-ghost btn-sm md:hidden"
            aria-label="Toggle navigation"
            onClick={() => setOpen(value => !value)}
          >
            <Menu className="h-5 w-5" />
          </button>
        </div>

        {open ? (
          <div className="mt-3 grid gap-2 rounded-2xl border border-white/10 bg-base-200/40 p-3 md:hidden">
            {navLinks.map(({ href, label, Icon }) => (
              <a
                key={href}
                href={href}
                className="flex items-center gap-2 rounded-xl px-3 py-2 text-sm text-base-content/85 transition hover:bg-base-300/40"
                onClick={() => setOpen(false)}
              >
                <Icon className="h-4 w-4 text-primary" />
                {label}
              </a>
            ))}
            <a
              href="https://discord.gg/69fQ5hqux9"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost btn-sm justify-start border border-white/10"
            >
              <ExternalLink className="h-4 w-4" />
              Discord
            </a>
            <a href="#join" className="btn btn-primary btn-sm justify-start" onClick={() => setOpen(false)}>
              Join now
            </a>
          </div>
        ) : null}
      </Container>
    </header>
  );
};
